export enum DotRezPaymentTypeGraphqlEnum {
    ExternalAccount = "ExternalAccount",
    PrePaid = "PrePaid",
    AgencyAccount = "AgencyAccount",
    CustomerAccount = "CustomerAccount",
    Voucher = "Voucher",
    Loyalty = "Loyalty"
}

export enum DotRezPaymentCode {
    Voucher = "VO"
}

export enum DotRezPaymentStatusGraphqlEnum {
    New ="New",
    Received = "Received",
    Pending = "Pending",
    Approved = "Approved",
    Declined = "Declined",
    Unknown = "Unknown",
    PendingCustomerAction = "PendingCustomerAction"
}

export enum DotRezPaymentAuthorizationStatusGraphqlEnum {
    Unknown = "Unknown", 
    Acknowledged = "Acknowledged", 
    Pending = "Pending", 
    InProcess = "InProcess", 
    Approved = "Approved", 
    Declined = "Declined", 
    Referral = "Referral", 
    PickUpCard = "PickUpCard", 
    HotCard = "HotCard", 
    Voided = "Voided", 
    Retrieval = "Retrieval", 
    ChargedBack = "ChargedBack", 
    Error = "Error", 
    ValidationFailed = "ValidationFailed", 
    Address = "Address", 
    VerificationCode = "VerificationCode", 
    FraudPrevention = "FraudPrevention", 
    ForcedApproval = "ForcedApproval", 
    ForcedDecline = "ForcedDecline"
}
